var map = {
	"./logo-alphabet.svg": 720,
	"./logo-amazon-2.svg": 721,
	"./logo-amazon.svg": 776,
	"./logo-azercell.svg": 777,
	"./logo-bank-of-america.svg": 778,
	"./logo-barclays.svg": 779,
	"./logo-bbc.svg": 780,
	"./logo-bloomberg.svg": 722,
	"./logo-bnp-paribas.svg": 781,
	"./logo-booking.svg": 782,
	"./logo-citibank.svg": 783,
	"./logo-cnbc.svg": 723,
	"./logo-cnbc2.svg": 784,
	"./logo-coca-cola-auto.svg": 719,
	"./logo-coca-cola-white.svg": 1674,
	"./logo-coca-cola.svg": 785,
	"./logo-deloitte.svg": 786,
	"./logo-experian.svg": 787,
	"./logo-facebook.svg": 788,
	"./logo-forbes.svg": 724,
	"./logo-g.svg": 1675,
	"./logo-goldman-sachs-new.svg": 789,
	"./logo-goldman-sachs.svg": 1477,
	"./logo-google-new.svg": 790,
	"./logo-google.svg": 791,
	"./logo-h.svg": 792,
	"./logo-henkel.svg": 793,
	"./logo-hsbc-new.svg": 794,
	"./logo-hsbc.svg": 1475,
	"./logo-ikea-new.svg": 795,
	"./logo-ikea.svg": 1676,
	"./logo-infineon.svg": 796,
	"./logo-instagram-icon.svg": 717,
	"./logo-instagram.svg": 797,
	"./logo-jp-morgan.svg": 798,
	"./logo-jti.svg": 799,
	"./logo-linkedin.svg": 800,
	"./logo-meta-new.svg": 716,
	"./logo-meta.svg": 1579,
	"./logo-morgan-stanley-new.svg": 801,
	"./logo-morgan-stanley.svg": 1476,
	"./logo-netflix.svg": 1473,
	"./logo-oracle.svg": 725,
	"./logo-paypal.svg": 802,
	"./logo-pwc-new.svg": 718,
	"./logo-pwc.svg": 1677,
	"./logo-spotify.svg": 1474,
	"./logo-tesla.svg": 803,
	"./logo-usa-today.svg": 726,
	"./logo-visa.svg": 804,
	"./logo-walmart.svg": 727,
	"./logo-wsj.svg": 728,
	"./logo-youtube.svg": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1335;